// 홈서비스 약관
export const terms = {
	terms: {
		displayNavigate: true,
		componentIndex: 0,
		componentName: 'Terms',
		title: '홈서비스 이용약관',
		deploy: [
			{
				date: '2024/01/18',
				ver: 5,
			},
			{
				date: '2023/08/01',
				ver: 4,
			},
			{
				date: '2022/08/30',
				ver: 3,
			},
			{
				date: '2020/05/21',
				ver: 2,
			},
			{
				date: '2019/07/16',
				ver: 1,
			},
		],
	},

	contract: {
		displayNavigate: true,
		componentIndex: 1,
		componentName: 'Contract',
		title: '홈서비스 매매약관',
		deploy: [
			{
				date: '2023/08/01',
				ver: 2,
			},
			{
				date: '2019/07/16',
				ver: 1,
			},
		],
	},

	refund: {
		displayNavigate: true,
		componentIndex: 2,
		componentName: 'Refund',
		title: '홈서비스 환불약관',
		deploy: [
			{
				date: '2023/08/01',
				ver: 5,
			},
			{
				date: '2022/08/30',
				ver: 4,
			},
			{
				date: '2020/05/21',
				ver: 3,
			},
			{
				date: '2020/02/11',
				ver: 2,
			},
			{
				date: '2019/12/17',
				ver: 1,
			},
		],
	},

	privacy: {
		displayNavigate: false,
		componentIndex: 3,
		componentName: 'Privacy',
		title: '개인정보 수집 이용제공',
		deploy: [
			{
				date: '2021/11/23',
				ver: 3,
			},
			{
				date: '2020/05/21',
				ver: 2,
			},
			{
				date: '2019/07/16',
				ver: 1,
			},
		],
	},

	consignment: {
		displayNavigate: false,
		componentIndex: 4,
		componentName: 'Consignment',
		title: '개인정보처리의 위탁에 관한 사항 동의',
		deploy: [
			{
				date: '2024/05/28',
				ver: 4,
			},
			{
				date: '2023/03/03',
				ver: 3,
			},
			{
				date: '2020/05/21',
				ver: 2,
			},
			{
				date: '2019/07/16',
				ver: 1,
			},
		],
	},
};

// 엔카보증 약관
export const refund = {
	'refund-warranty': {
		displayNavigate: true,
		componentIndex: 0,
		componentName: 'RefundWarranty',
		title: '엔카보증 이용 및 환불약관 동의',
		deploy: [
			{
				date: '2023/01/31',
				ver: 4,
			},
			{
				date: '2020/11/24',
				ver: 3,
			},
			{
				date: '2020/05/21',
				ver: 2,
			},
			{
				date: '2019/07/16',
				ver: 1,
			},
		],
	},

	'privacy-warranty': {
		displayNavigate: true,
		componentIndex: 1,
		componentName: 'PrivacyWarranty',
		title: '개인정보 수집/이용 동의',
		deploy: [
			{
				date: '2022/08/30',
				ver: 2,
			},
			{
				date: '2019/07/16',
				ver: 1,
			},
		],
	},

	provide: {
		displayNavigate: true,
		componentIndex: 2,
		componentName: 'Provide',
		title: '개인정보 제3자 제공 동의',
		deploy: [
			{
				date: '2022/08/30',
				ver: 2,
			},
			{
				date: '2019/07/16',
				ver: 1,
			},
		],
	},
};
